import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  // eslint-disable-next-line @stylistic/line-comment-position -- FIXME
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: { pl: {} },
    fallbackLng: 'pl',
    debug: false,
    // eslint-disable-next-line @stylistic/line-comment-position -- FIXME
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      // eslint-disable-next-line @stylistic/line-comment-position -- FIXME
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
